import cn from "classnames";
import { MenuButton } from "../MenuButton/MenuButton";
import styles from "./BorderMenu.module.css";

interface BorderColorButton {
    color: string;
    selectedColor: string;
    isTransparent: boolean;
    isWhite: boolean;
    onClick: (color: string) => void;
}

export function BorderColorButton({
    color,
    selectedColor,
    isTransparent,
    isWhite,
    onClick,
}: BorderColorButton) {
    const handleClick = () => {
        onClick(color);
    };

    const colorStyles = cn(
        styles.color,
        isTransparent && styles.transparent,
        isWhite && styles.white,
    );

    return (
        <MenuButton
            className={color === selectedColor ? styles.selected : ""}
            onClick={handleClick}
        >
            <div className={colorStyles} style={{ backgroundColor: color }} />
        </MenuButton>
    );
}
